export const CLIENTS_SLUGS = {
    DANONE_ONE: 'danone-one',
    JTI_CONNECT: 'jti-connect',
    DOTS: 'dots',
    DOTS_II: 'dots-ii',
    KC: 'kimberly-one',
    SALESBOOK: 'salesbook-one',
    WWP: 'wwp-winwiththepartner',
    SP: 'shell-somosprotagonistas',
    WTS: 'beiersdorf-wts',
    MARS: 'mars-betthertogether',
    SAVENCIA: 'savencia-one',
    MITSUBISHI: 'one-mitsubishi',
    AURA: 'aura-one',
    LESAFFRE: 'lesaffre-one',
    PFIZER: 'one-pfizer',
    BRANCA: 'branca-one',
    AXUM: 'axum-one'
};